// Unpublished Work © 2021-2022 Deere & Company

import {combineReducers} from 'redux';
import {reducerTcombWrapper} from '@deere/cap-it-ui.redux-store-creator';
import {contacts} from './contacts';
import {customer} from './customer';
import {status as pageStatus} from './status';
import {SelectBusinessContact} from '../../state/struct/select-business-contact';

export const getSelectBusinessContactReducer = () => {
    const combinedReducer = combineReducers({
        contacts,
        customer,
        pageStatus
    });

    return reducerTcombWrapper.bind(
        this,
        {
            combinedReducer,
            stateStruct: SelectBusinessContact
        }
    );
};
